<template>
  <div>
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      size="sm"
      :title="title"
      @ok="onYes"
      @cancel="onNo"
    >
      <label>{{ message }}</label>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("Sim") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("Não") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  methods: {
    show() {
      this.$refs.openModal.show();
    },
    hide() {
      this.$refs.openModal.show();
    },
    onNo() {
      this.$emit("no");
      this.$refs.openModal.hide();
    },
    onYes() {
      this.$emit("yes");
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>

